export default __webpack_public_path__ + "static/media/page-collection.85256678.png";